import { TextField } from "@mui/material";
import styles from "./styles.module.css";
import styled from "styled-components";
import BlueButton from "../../BlueButton";
import ForumTwoToneIcon from "@mui/icons-material/ForumTwoTone";
import WhiteButton from "../../WhiteButton";

const StyledContainerMsg = styled.div`
  height: ${(props) => (props.open ? "175px" : "0px")};
  overflow: hidden;
  transition: all 0.3s ease;
  transform-origin: top;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: ${(props) => (props.open ? "10px" : "0px")};
`;

const SendMsg = ({
  contentMsg,
  onSubmit,
  open,
  setOpen,
  loading,
  onCloseModal,
  ...rest
}) => {
  return (
    <>
      <StyledContainerMsg open={open}>
        <TextField
          label="Descreva aqui sua solicitação"
          variant="outlined"
          helperText={contentMsg.helperText}
          fullWidth
          multiline
          rows={5}
          value={contentMsg.value}
          error={contentMsg.error}
          {...rest}
        />
      </StyledContainerMsg>
      <div className={styles.action__sendMsg}>
        <WhiteButton clickFunction={onCloseModal} textValue="Fechar" />
        {contentMsg.renderButton ? (
          <BlueButton
            disabled={loading}
            textValue={
              open ? "Enviar mensagem" : "Escreva sua mensagem"
            }
            contentStartIcon={<ForumTwoToneIcon />}
            clickFunction={() => (open ? onSubmit() : setOpen(true))}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default SendMsg;
